import {VentrataDataProvider} from 'components/common/CartItemBuilder/providers/VentrataDataProvider'
import {size} from 'lodash'
import {Option} from './Option'

export const MaximizedOptions = () => {
  const product = VentrataDataProvider.useProduct('optional')
  const availabilities = VentrataDataProvider.useAvailabilities('optional')

  if (!product.id) {
    return null
  }

  const hasAvailabilities = size(availabilities) > 0

  const visibleOptions = hasAvailabilities
    ? product.options.filter((option) => {
        const optionAvailabilities = availabilities[option.id]
        if (!optionAvailabilities || optionAvailabilities.length === 0) return true
        return optionAvailabilities.some((availability) => availability.available)
      })
    : product.options

  return (
    <div className="flex flex-col gap-4">
      {visibleOptions.map((option) => {
        return <Option key={option.id} option={option} />
      })}
    </div>
  )
}
